import { withInstall } from '@vuesax-alpha/utils'

import Scrollbar from './src/scrollbar.vue'

export const VsScrollbar = withInstall(Scrollbar)
export default VsScrollbar

export * from './src/util'
export * from './src/scrollbar'
export * from './src/thumb'
